module.exports = __webpack_public_path__ + "img/obasf.8fca8695.png";